// A reported zero is data the analyst entered. Only missing or blank counts as empty.
const hasReportedValue = (value: unknown) => value !== null && value !== undefined && String(value).trim() !== '';

export default hasReportedValue;
